import type { PublicRouteState } from '../lib/publicRoute'

/** Only the four localized home documents opt into the landing runtime. */
export function isLandingExperienceRoute(route: PublicRouteState | null): boolean {
  return route?.pageType === 'semantic' && route.semanticKind === 'index'
}
